import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { DecimalPipe, DatePipe } from '@angular/common';
import { HttpBackend } from '@angular/common/http';
import { NgbModule, NgbTypeaheadConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader, TranslateService, TranslatePipe } from '@ngx-translate/core';

import { AuthService, AuthGuardService} from './auth/';
import { RequestService } from './request/request.service';

// SysBiz API
import { Sysbiz } from 'src/app/config/sysbiz';
import { provideSysbiz } from './sysbiz/sysbiz.module';
import { SysbizSdiService } from './sysbiz/sysbiz-sdi.service';
import { SysbizAuthService } from './sysbiz/sysbiz-auth.service';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { BankingRedirectGuard } from './auth/banking-redirect.guard';

export function createTranslateLoader(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/base/i18n/', suffix: '.json' },
    { prefix: './assets/i18n/', suffix: '.json' }
  ]);
}

export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    importProvidersFrom(
      NgbModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpBackend]
        }
      })
    ),
    {
      provide: NgbTypeaheadConfig,
      useFactory: () => {
        const config = new NgbTypeaheadConfig();
        config.container = 'body';
        return config;
      }
    },
    provideSysbiz(Sysbiz),
    AuthService,
    AuthGuardService,
    BankingRedirectGuard,
    TranslateService,
    TranslatePipe,
    RequestService,
    SysbizAuthService,
    SysbizSdiService,
    DecimalPipe,
    DatePipe
  ]);
}

